var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"href":"https://manual.sklady.jagu.cz/","target":"_blank"}},[_c('v-icon',[_vm._v(" help ")]),_c('span',{staticClass:"mx-3"},[_vm._v(" "+_vm._s(_vm.$t('base.help.title'))+" ")]),_c('v-icon',[_vm._v(" $openItem ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }